import type { ChatsV2Translations } from '../interfaces/chatsV2';

export const chatsV2Translations: ChatsV2Translations = {
  page_title: 'Chats',

  inbox_all: 'All',
  inbox_mine: 'Assigned to me',
  inbox_unread: 'Unread',
  inbox_handoff: 'Awaiting human',
  inbox_closed: 'Closed',

  channel_all: 'All channels',
  channel_whatsapp: 'WhatsApp',
  channel_instagram: 'Instagram',
  channel_web: 'Web Chat',
  channel_messenger: 'Messenger',

  account_all_label: 'All accounts',
  account_select_label: 'Account',

  search_placeholder: 'Search conversations, numbers, emails…',
  new_conversation: 'New conversation',
  toggle_context_show: 'Show details',
  toggle_context_hide: 'Hide details',

  conversation_count: '{{count}} conversations',
  sort_recent: 'Recent',
  sort_priority: 'Priority',

  header_take_over: 'Take over',
  header_auto_on: 'Auto',
  header_auto_off: 'Paused',
  header_auto_paused_notice:
    'Auto-reply paused. The agent will not respond. Any message will be sent from your account.',
  header_resume: 'Resume',

  composer_placeholder: 'Type a message, or use / to insert a template…',
  composer_reply_as: 'Reply as:',
  composer_reply_as_human: 'human',
  composer_reply_as_agent: 'agent',
  composer_send: 'Send',
  composer_outbound_via: 'Will go out via',
  composer_attach: 'Attach',
  composer_window_expired_hint: "More than 24h have passed since the customer's last message. You can only send an approved template.",
  composer_window_never_hint: "The customer has not written yet. To start the conversation you must send an approved template.",
  composer_window_closing: "The 24h window closes in {{hours}}h",
  composer_send_template: "Send template",
  template_sent_notice: "Sending a template does not reopen the 24h window — only a reply from the customer does.",
  composer_templates: 'Templates',
  composer_send_checkout: 'Send checkout',

  lead_score_label: 'Lead score',
  lead_hot: 'Hot',
  lead_warm: 'Warm',
  lead_cold: 'Cold',
  lead_score_intent: 'Intent',
  lead_score_engagement: 'Engagement',
  lead_score_budget: 'Budget',
  lead_score_urgency: 'Urgency',
  lead_score_pending: 'Pending analysis',
  data_collected_empty: 'No lead information collected yet',
  actions_empty: 'No actions logged yet',
  context_force_analyze: 'Force analysis',
  context_analyzing: 'Analyzing…',
  context_analyze_error: 'Could not queue the analysis',
  context_empty_title: 'Pick a conversation',
  context_empty_description:
    'Lead detail, agent actions and internal notes will show up here once you pick a chat from the list.',
  send_failed: 'Could not send the message',
  composer_placeholder_locked:
    'Pause the agent to reply manually from here',
  composer_locked_hint: 'The agent is auto-replying',
  header_pause_agent: 'Pause agent',
  header_resume_agent: 'Resume agent',
  header_paused_notice:
    'The agent is paused. Messages you send will go out as human until you resume.',
  notes_save: 'Save note',
  notes_saved: 'Note saved',
  notes_save_error: 'Could not save the note',
  message_human_sent_by: 'Sent by',
  system_event_human_takeover: 'Operator took control',
  system_event_human_released: 'Operator handed control back to the agent',
  system_event_handoff_triggered: 'Agent requested human intervention',
  system_event_agent_error: 'The agent failed to process the message',
  system_event_follow_up_dispatched: 'Automatic follow-up sent',
  system_event_conversation_closed: 'Conversation closed',

  stage_label: 'Stage',
  stage_contact: 'Contact',
  stage_qualified: 'Qualified',
  stage_quote: 'Quote',
  stage_close: 'Close',

  data_collected_title: 'Collected data',
  data_collected_edit: 'Edit',
  actions_title: 'Agent actions',
  notes_title: 'Internal notes',
  notes_placeholder: 'Only visible to your team…',

  context_action_profile: 'Profile',
  context_action_tag: 'Tag',
  context_action_close: 'Close',

  tab_lead: 'Lead',
  tab_history: 'History',
  tab_actions: 'Actions',
  tab_history_placeholder: 'Customer history coming soon.',
  tab_actions_placeholder: 'Quick actions coming soon.',

  ai_suggestion_eyebrow: 'Agent suggestion',
  ai_suggestion_apply: 'Apply',
  ai_suggestion_dismiss: 'Dismiss',

  typing_label: 'is typing…',
  today_pill: 'Today',
  empty_state_title: 'Select a conversation',
  empty_state_description: 'Pick a chat from the list to see the details.',
};
